// extracted by mini-css-extract-plugin
export default {"signupContainer":"EdfAui7M","button":"_fVXB6Ok"};